import { BillingMethodEnum } from "@enums/billingMethodEnum.enum"
import { InvoiceItemDto } from "./invoiceItemDto"
import { UserDto } from "./userDto"
import { InvoiceStatusEnum } from "@enums/invoiceStatusEnum.enum"

export class InvoiceDto {
  id: number
  invoiceNumber: string

  invoiceMeterAmount: number

  invoiceAmount: number
  tax: number
  subtotal: number

  createdAt: Date
  dueAt?: Date
  paidAt?: Date

  ownerUserId: string
  ownerUser: UserDto
  ownerCustomerId: number
  ownerCompany?: string
  ownerFirstName?: string
  ownerLastName?: string
  ownerFullName?: string
  ownerStreet: string
  ownerHouseNumber: string
  ownerPostcode: string
  ownerCity: string
  ownerEmail?: string
  ownerPhone?: string
  ownerCeo: string
  ownerVatId: string
  ownerCommercialRegister: string
  ownerCommercialRegisterId: string
  ownerBank: string
  ownerIban: string
  ownerBic: string

  recipientUserId?: string
  recipientUser: UserDto
  recipientCompany?: string
  recipientFirstName?: string
  recipientLastName?: string
  recipientFullName: string
  recipientGender?: string
  recipientStreet: string
  recipientHouseNumber: string
  recipientPostcode: string
  recipientCity: string
  recipientEmail?: string
  recipientPhone?: string

  pdfDownloadUrl: string
  invoiceType: number
  stripeCustomerId: string
  paymentMethod: string
  paymentMethodLast4: string
  paymentMethodExpires: string
  invoiceItems: InvoiceItemDto[]
  billingMethod: BillingMethodEnum
  type: string
  payoutStatementId: number
  status: InvoiceStatusEnum
}
